import pink from './Assets/pink.svg';
import orange from './Assets/orange.svg';
import purple from './Assets/purple.svg';
import dgrey from './Assets/dgrey.svg';
import grey from './Assets/grey.svg';
import yellow from './Assets/yellow.svg';
import green from './Assets/green.svg';
import blue from './Assets/blue.svg';

// update this here and then on the BE OMS config, to reset the cache
// and get latest changes
export const CMP_CURRENT_VERSION = 5;

export const ORIGINAL_VIAL_BODY = 'ORIGINAL_VIAL_BODY';
export const OFFLINE_BODY_BCK = 'OFFLINE_BODY_BCK_';
export const STORE_STRUCT = 'STORE_STRUCT';
export const STORE_TASKID = 'STORE_TASK';
export const STORE_UUID = 'STORE_UUID';
export const STATUS_SKIPPED = 9999;
export const EDIT = 'edit';
export const RESCAN = 'rescan';
export const SCAN = 'scan';
export const VIEW = 'view';
export const CHANGE = 'change';
export const SKIP = 'skip';
export const DEFAULT = 'default';
export const DELAY = 'delay';
export const BARCODE = 'BARCODE';
export const BREACH_CHECKED = 'BREACH_CHECKED';
export const DEVICE_ID = 'DEVICE_ID';
export const MARK_ACCESSIONED = 'MARK_ACCESSIONED';
export const LEAD_12_ECG_VIAL_ID = 44;
export const LEAD_6_ECG_VIAL_ID = 40;
export const HOME_URL = 'HOME_URL';
export const REQ_ID = 'REQ_ID';
export const CUSTOMER_ID = 'CUSTOMER_ID';
export const MOBILE_NUMBER = 'MOBILE_NUMBER';
export const MEMBER_MODE = 'MEMBER_MODE';
export const ACTIVE_TASK_COUNT = 'ACTIVE_TASK_COUNT';
export const ADDED_PATIENTS_ARRAY = 'ADDED_PATIENTS_ARRAY';
export const NEW_ADDED_NAMES = 'NEW_ADDED_NAMES';
export const OH_NOTES_LINK = 'OH_NOTES_LINK';
export const DOCUMENT_BODY = 'DOCUMENTS_BODY';
// BLOOD_PRESSURE_VIAL_ID is also interchangable with any vitals vial
// since cmp takes multiple vitals as input
export const BLOOD_PRESSURE_VIAL_ID = 45;
export const HOURS_24 = '24';
export const URINE = 'urine';
export const TIME_SETTINGS = {
  timeZone: 'Asia/Kolkata',
  hour12: false,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
};
export const TIME_SETTINGS_NOSECOND = {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hour12: true,
};
// 3 calls
export const RNR_CALL_NOS = 3;
// 5 mins past slot time
export const RNR_SECS_PAST_SLOT = 300;
export const VIALMAPPING = {
  1: grey,
  2: grey,
  3: grey,
  4: pink,
  5: orange,
  6: orange,
  7: grey,
  8: purple,
  9: dgrey,
  10: grey,
  11: yellow,
  12: yellow,
  13: green,
  14: grey,
  15: grey,
  16: grey,
  17: grey,
  18: grey,
  19: grey,
  20: grey,
  21: grey,
  22: grey,
  23: grey,
  24: grey,
  25: grey,
  26: grey,
  27: grey,
  28: grey,
  29: grey,
  30: grey,
  31: grey,
  32: grey,
  33: dgrey,
  34: dgrey,
  35: dgrey,
  36: dgrey,
  37: dgrey,
  38: blue,
  39: grey,
  40: grey,
  41: grey,
  9999: grey,
};

export const VIALSLIST = ['Biopsy', 'Citrate', 'Culture Bottle', 'Culture Bottle - Pediatric', 'Dark Sterile Can', 'Dark Sterile Container', 'EDTA', 'EDTA in Aluminium Foil', 'Fluoride', 'Fungus Agar Slant', 'Gel', 'Gel in Aluminium Foil', 'Heparin', 'LBC Container', 'Nasal Swab', 'Paraffin Block', 'Slides', 'Sterile Can', 'Sterile Container', 'Sterile Container - Fluid', 'Sterile Container - Formalin', 'Sterile Container - Hair', 'Sterile Container - Nail', 'Sterile Container - Saline', 'Sterile Container - Semen', 'Sterile Container - Stone', 'Sterile Container - Stool', 'Sterile Container - Urine', 'Sterile Container - Acid', 'Streck Tube', 'Swab', 'Virus Transport Medium', 'Fluoride 1 hour', 'Fluoride 2 hours', 'Fluoride 3 hours', 'Fluoride 4 hours', 'Fluoride 5 hours', 'EDTA(Metal Free)', 'Serum(Metal Free)', '6-Lead ECG', 'Sterile Container-CSF'];

export const MainStyles = {
  SubmitContainer: {
    width: '100%',
    backgroundColor: '#fff',
    position: 'fixed',
    bottom: 0,
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
    height: '80px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    maxWidth: '960px',
  },
  SubmitBox: {
    width: '100%',
    marginLeft: '16px',
    marginRight: '16px',
  },
  SubmitButton: {
    color: '#fff',
    textTransform: 'none',
    height: '48px',
    width: '100%',
    backgroundColor: '#ff970a',
    ':hover': {
      color: '#fff',
      width: '100%',
      backgroundColor: '#ff970a',
    },
    borderRadius: '8px',
    boxShadow: '0 2px 12px 0 rgba(255, 151, 10, 0.31)',
  },
  DoneButton: {
    color: '#ff970a',
    textTransform: 'none',
    height: '48px',
    width: '100%',
    borderRadius: '8px',
    backgroundColor: '#fff',
    border: '1px solid #ff970a',
    ':hover': {
      color: '#ff970a',
      width: '100%',
      backgroundColor: '#fff',
    },
  },
  SubmitContainerOffline: {
    width: '100%',
    backgroundColor: '#fff',
    position: 'fixed',
    bottom: 0,
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
    height: '100px',
    display: 'flex',
    borderTopRightRadius: '22px',
    borderTopLeftRadius: '22px',
    justifyContent: 'center',
    alignItems: 'center',
  },
  OfflineAlertBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '8px',
  },
  OfflineIcon: {
    color: '#F44336',
    fontSize: 16,
  },
  OfflineText: {
    marginLeft: '8px',
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 13,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#F44336',
  },
  SubmitText: {
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ffffff',
  },
  DoneText: {
    height: 20,
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ff970a',
  },
  DoneTextLoading: {
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ff970a',
  },
  Snackbar: {
    bottom: 0,
    position: 'fixed',
    marginBottom: '88px',
  },
  SnackBarMemberMode: {
    bottom: 0,
    position: 'fixed',
    marginBottom: '138px',
  },
  Alert: {
    borderRadius: 24,
    backgroundColor: '#01b37a',
    color: '#fff',
    '.MuiAlert-message': {
      padding: '10px 0',
      width: `${window.screen.width * 0.7}px`,
    },
  },
  AlertSkip: {
    borderRadius: 24,
    backgroundColor: '#b39901',
    color: '#fff',
    '.MuiAlert-message': {
      padding: '10px 0',
      width: `${window.screen.width * 0.7}px`,
    },
  },
  AlertError: {
    borderRadius: 24,
    backgroundColor: '#e60709',
    color: '#fff',
    '.MuiAlert-message': {
      padding: '10px 0',
      width: `${window.screen.width * 0.7}px`,
    },
  },
  AlertTypo: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ffffff',
  },
  cancelRescheduleHeader: {
    marginTop: '24px',
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  CountDownCard: {
    padding: '16px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    marginTop: '18px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: 2,
  },
  CountDownCardRnrDone: {
    paddingTop: '16px',
    paddingBottom: '16px',
    paddingRight: '16px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    marginTop: '18px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: 2,
  },
  // #E74C3C, #ffe6e6
  RNRButtonRolling: {
    marginTop: '12px',
    width: '100%',
    backgroundColor: '#E74C3C',
    color: '#E74C3C',
    border: '1px solid #E74C3C',
    borderRadius: 2,
    fontFamily: 'Montserrat',
    textTransform: 'none',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    ':hover': {
      backgroundColor: '#E74C3C',
      color: '#E74C3C',
      border: '1px solid #E74C3C',
    },
  },
  RNRButton: {
    marginTop: '12px',
    width: '100%',
    backgroundColor: '#ffe6e6',
    color: '#E74C3C',
    border: '1px solid #E74C3C',
    borderRadius: 2,
    fontFamily: 'Montserrat',
    textTransform: 'none',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    ':hover': {
      backgroundColor: '#ffe6e6',
      color: '#E74C3C',
      border: '1px solid #E74C3C',
    },
  },
  CallButton: {
    marginLeft: '16px',
    marginTop: '12px',
    width: `${window.screen.width - 32}px`,
    backgroundColor: '#28B463',
    color: '#fff',
    border: '1px solid #28B463',
    borderRadius: 2,
    fontFamily: 'Montserrat',
    textTransform: 'none',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
    ':hover': {
      backgroundColor: '#28B463',
      color: '#fff',
      border: '1px solid #28B463',
    },
  },
  RNRButtonDisabled: {
    marginTop: '12px',
    width: '100%',
    backgroundColor: '#F2F3F4',
    color: '#A6ACAF',
    borderRadius: 2,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    boxShadow: 'rgba(99, 99, 99, 0.2) 0px 2px 8px 0px',
  },
  CountDownBox: {
    display: 'flex',
    alignItems: 'center',
  },
  WarningIcon: {
    height: 50,
    width: 50,
    color: '#ff970a',
  },
  CallBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 40,
    height: 40,
    color: '#fff',
    backgroundColor: '#28B463',
    borderRadius: '50%',
  },
  CallIcon: {
    fontSize: 20,
    marginRight: '8px',
  },
  MinutesTypo: {
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 20,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
    span: {
      fontSize: 14,
      fontWeight: '500',
    },
  },
  CallTypo: {
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 14,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
  RnrInfo: {
    marginLeft: '16px',
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#3c3c3c',
  },
};

export const OrderCancelledStyles = {
  OrderCancelledContainer: {
    marginTop: `${window.screen.height * 0.25}px`,
  },
  CardContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  CardContainerMidAlign: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  SuccessCard: {
    display: 'flex',
    marginTop: '12px',
    marginLeft: '16px',
    marginRight: '16px',
    borderRadius: '16px',
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    '#lottiesuccess': {
    },
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '32px',
  },
  SuccessCardMidAlign: {
    display: 'flex',
    borderRadius: 2,
    boxShadow: '0 2px 4px 0 rgba(0, 0, 0, 0.06)',
    '#lottiesuccess': {
    },
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px',
  },
  SuccessDetails: {
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#3c3c3c',
  },
  SuccessDetailsMidAlign: {
    marginTop: '16px',
    fontFamily: 'Montserrat',
    fontSize: 16,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#01B37A',
  },
  ActionBottomContainer: {
    marginTop: '16px',
    position: 'fixed',
    width: '100%',
    bottom: 0,
    boxShadow: '0 -2px 6px 0 rgba(0, 0, 0, 0.08)',
  },
  ActionRightText: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#ff970a',
  },
  ActionRightTextMidAlign: {
    height: 20,
    textTransform: 'none',
    fontFamily: 'Montserrat',
    fontSize: 15,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: '#fff',
  },
  ActionButton: {
    marginLeft: '24px',
    marginRight: '24px',
    marginTop: '16px',
    marginBottom: '16px',
    display: 'flex',
  },
  ActionRight: {
    height: 48,
    borderRadius: 2,
    backgroundColor: '#fff',
    border: '1px solid #ff970a',
    color: '#616161',
    width: '100%',
    ':hover': {
      backgroundColor: '#fff',
      color: '#616161',
    },
  },
  ActionButtonMidAlign: {
    height: 48,
    marginTop: '24px',
    width: '100%',
    borderRadius: 2,
    backgroundColor: '#ff970a',
    border: '1px solid #ff970a',
    color: '#fff',
    ':hover': {
      backgroundColor: '#ff970a',
      border: '1px solid #ff970a',
      color: '#fff',
    },
  },
  Snackbar: {
    bottom: 0,
    position: 'fixed',
    marginBottom: '88px',
  },
  Alert: {
    borderRadius: 24,
    backgroundColor: '#01b37a',
    color: '#fff',
    '.MuiAlert-message': {
      padding: '10px 0',
      width: `${window.screen.width * 0.7}px`,
    },
  },
  AlertTypo: {
    fontFamily: 'Montserrat',
    fontSize: 12,
    fontWeight: '600',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#ffffff',
  },
};
